import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import queryString from 'query-string';
import DashboardFooter from '../commonFiles/DashboardFooter';
import DashboardPageNotFound from '../commonFiles/DashboardPageNotFound';
import UserNavbar from './UserNavbar';
import FreeConsultation from './FreeConsultation';
import Calendar from './Calendar';

class AdminInfo extends Component {
  constructor() {
    super();
    this.state = {
        app_view:'',
        userNavbar:'',
    };
  }

check_user_login_not(){
  let cutThis = this;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('web_token',web_token);
   body.append('function','check_user_session');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/user_free_consultation_url.php";
   }else{
     url = "/php/user_free_consultation_url.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var data = res.data;
      if(data==0){
        window.location.href = '/';
      }
    })
    .catch(function (error) {
        console.log(error);
    });
}
  componentDidMount() {
    var location        = window.location;
    const parsed        = queryString.parse(location.search);
    var user_app_token  = parsed['user_number'];
    var user_token      = parsed['token'];
    if(user_app_token!='' && user_token!=''){
      var userNavbar = <UserNavbar open_menu_page={this.open_selected_page.bind(this)} user_token={user_token} user_app_token={user_app_token}/>;
      this.setState({userNavbar});
      this.open_selected_page('calendar',user_app_token,user_token);
    }
  }


  open_selected_page(list_name,user_app_token,user_token){
    this.check_user_login_not();
    var app_view = '';
    switch(list_name) {
     case 'calendar':
        app_view = <Calendar user_token={user_token} user_app_token={user_app_token}/>;
      break;
     case 'freeConsultation':
        app_view = <FreeConsultation user_token={user_token} user_app_token={user_app_token}/>;
      break;
     default:
        app_view = <DashboardPageNotFound/>;
    }
    this.setState({app_view});
  }

  render() {
    return (
        <>
        {this.state.userNavbar}
        <main role="main" className="col-md-9 ml-sm-auto col-lg-10 main" id="dashboard_right_card">
            {this.state.app_view}
            <DashboardFooter/>
        </main>
        </>
    );
  }
}

export default AdminInfo;
